<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/proprietario"> Cadastro/Equipamento/Proprietários </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Proprietário *"
              v-model="nome"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Proprietário é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="CNPJ *"
              v-model="cnpj"
              v-uppercase
              v-mask="['##.###.###/####-##']"
              :counter="18"
              :rules="[(v) => !!v || 'O CNPJ é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Contato *"
              v-model="contato"
              :counter="100"
              :rules="[(v) => !!v || 'O Contato é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Celular *"
              v-model="celular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              :rules="[(v) => !!v || 'O Celular é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="2">
          <v-checkbox :readonly="readOnly" v-model="proprietario.ativo" label="Ativo"></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn to="/proprietario" color="error" class="mr-4" v-if="!readOnly"> Voltar </v-btn>
          <v-btn to="/proprietario" color="success" class="mr-4" v-else> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import {
  editarProprietarioAsync
} from "@/services/proprietarioService";
import { mapState } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarProprietario",
  data: () => ({
    overlay: false,
    nome: null,
    cnpj: null,
    contato: null,
    celular: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("equipamento", ["proprietario"]),
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        const resposta = await editarProprietarioAsync(
          this.proprietario.id,
          this.nome,
          this.cnpj,
          this.contato,
          this.celular,
          this.proprietario.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/proprietario");
        }
      }
    },
  },
  created: function () {
    this.nome = this.proprietario.nome;
    this.cnpj = this.proprietario.cnpj;
    this.contato = this.proprietario.contato;
    this.celular = this.proprietario.celular;
  },
  mounted() {
    this.readOnly = !getUserPermission(7);
  },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>